import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

import { DomainAmazon } from 'features/globalSetup/features/amazon/types/domainAmazon'
import { Schema } from '../../schema'
import { DomainAmazonOption, useGetDomainAmazons } from '../useGetDomainAmazons'
import { UseDomainAmazonData } from './types'

export const useDomainAmazonData = (): UseDomainAmazonData => {
  const { loading, options } = useGetDomainAmazons()

  const { getValues, reset, setValue, watch } = useFormContext<Schema>()
  const { id } = watch()

  const selectFirstOption = (): void => setValue('id', options[0])

  const setDomainAmazonParams = (id: DomainAmazon['id']): void => {
    const { enabled } = options.find((option: DomainAmazonOption) => option.value === id) || {
      enabled: false,
    }

    reset({
      ...getValues(),
      enabled,
    })
  }

  useEffect(() => {
    if (options.length > 0 && id.value === '') {
      selectFirstOption()
    }
  }, [options])

  useEffect(() => {
    if (id.value !== undefined) {
      setDomainAmazonParams(id.value)
    }
  }, [id.value])

  return {
    loading,
    options,
  }
}
